/**
 * 获取画布中最大宽度下的文本内容
 * @param c
 * @param text
 * @param maxWidth
 * @returns
 */
export const fittingStringByWidth = (
  c: CanvasRenderingContext2D,
  text: string,
  maxWidth: number,
  letterSpace: number
) => {
  letterSpace = letterSpace ? letterSpace : 0;
  const width = c.measureText(text).width + (text.length - 1) * letterSpace;
  if (width <= maxWidth) return text;

  const ellipsis = '...';
  let res = '';
  for (let i = 0; i < ellipsis.length; i++) {
    const char = ellipsis[i];
    const res2 = res + char;
    const width = c.measureText(res2).width + (res2.length - 1) * letterSpace;
    if (width <= maxWidth) {
      res = res2;
    } else if (width > maxWidth) {
      return res;
    }
  }

  let res3 = '';
  for (let i = 0; i < text.length; i++) {
    const char = text[i];
    const res2 = res3 + char + ellipsis;
    const width = c.measureText(res2).width + (res2.length - 1) * letterSpace;
    if (width <= maxWidth) {
      res3 = res3 + char;
    } else if (width > maxWidth) {
      break;
    }
  }

  return res3 + ellipsis;
};

/**
 * 返回角度的弧度值
 * @param angle 角度
 * @returns
 */
export const toRadian = (angle: string | number) => {
  return (Number(angle) * Math.PI) / 180;
};

/**
 * 获取弧度值
 * @param arcWidth
 * @param arcRadius
 * @returns
 */
export const widthToRadian = (arcWidth: number, arcRadius: number) => {
  return toRadian((arcWidth * 180) / Math.PI / arcRadius);
};

export const getTextColorReg = () =>
  /#([0-9a-zA-Z][0-9a-zA-Z])?[0-9a-zA-Z]{6}\x20[^#]{1,}(?=#)/g;

export const getCanvasFont = (options: {
  fontSize: number;
  fontId: string;
  fontWeight: string;
}) => {
  const { fontSize, fontId, fontWeight } = options;
  const _fontId = fontId ? fontId : 'misans';
  const _fontWeight = fontWeight ? fontWeight : 'normal';
  const fontFamily = _fontId + '-' + _fontWeight;
  return `${fontSize}px ${fontFamily}`;
};

export const getArcLineHeight = (lineHeight: number, verticalAlign: string) => {
  return verticalAlign == 'center'
    ? lineHeight / 2
    : verticalAlign == 'top'
    ? lineHeight
    : 0;
};
